import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect
import logo from "../../Assets/images/gif/danger.gif";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function SingleFaculty() {
  const [samecoursetypeselectreload, SetsameCourseTypeSelectReload] = useState(false);
  const [collegetype, setCollegetype] = useState(false);
  const [singleFacultyCollegeCourseType, setSingleFacultyCollegeCourseType] = useState(false);
  const [type, setType] = useState(false);

  const [discipline, setDisciplineData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selctedsem, setsem] = useState(false);
  const [active, setActiveSemester] = useState(false);
  const [getresults, setResults] = useState();
  const [minors, setMinors] = useState([]);
  const [mdc, setMdc] = useState([]);
  const [AEC, setAEC] = useState([]);
  const [VAC, setVAC] = useState([]);
  const [SEC, setSEC] = useState([]);
  const [BevocMinors, setBevocMinors] = useState([]);
  const [BvocMDC, setBvocMDC] = useState([]);
  const [BvocAEC, setBvocAEC] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);

  const [flag, setflag] = useState(false);
  const [selectedAdmission, setSelectedAdmission] = useState(false);
  const [activeBvocEvent, setActiveBvocEvent] = useState(false);
  const [bvocActiveSemester, setBvocActiveSemester] = useState(false);
  const [activeUGP, setActiveUGP] = useState(false);
  const [activeBVoc, setActiveBVoc] = useState(false);

  const [current, setCurrent] = useState({

    minor: [],
    mdc: [],
    aec: [],
    VAC: [],
    SEC: [],
    BevocMinors: [],
    BvocMDC: [],
    BvocAEC: [],
  });

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }


  useEffect(() => {

    const fetchType = async () => {
      try {

        http.get(`getActiveEvents`, { params: { event_id: 1 } }).then(response => {

          if (response.data.http_status === 500) {
            setsem(1);
          }
          else {
            const activeSemesters = response.data[0].semester_id;
            const status = response.data[0].status;
            setsem(1);

            if (status === "active") {
              setActiveSemester(activeSemesters);
            }
          }

        }).catch(error => {
          console.error("Error in getStudentCourseEvents:", error);
          toast.error("Something went wrong");
        });

        const response2 = await http.get(`/Admin/getCollegeType`);
        setType(response2.data);

        if (response2.data === "SF") {
          setSingleFacultyCollegeCourseType("SF");

        }
        else {
          setSingleFacultyCollegeCourseType(false);

        }

        if (response2.data !== "BOTH") {
          setCollegetype(response2.data);
        }

      } catch (error) {

        console.error('Error fetching Course data:', error);
      }
    };

    fetchType();

  }, []);

  useEffect(() => {

    let cid = localStorage.getItem("collegeid");
    const fetchData = async () => {
      try {

        const response2 = await http.get(`/Admin/getSingleFacultyDisciplines`, {
          params: {
            limit: '500',
            college_id: cid,
            college_course_type: collegetype,
            admission_year: selectedAdmission.Adimission_year

          }
        });


        if (response2.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response2.data);

        setSelected(prevSelected => {
          const newSelected = response2.data.reduce((acc, option) => {
            if (option.selected === 1 && !acc.includes(option.id)) {
              return [...acc, option.id];
            }
            return acc;
          }, [...prevSelected]);

          return newSelected;
        });


      } catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
          toast.error(error.response.data.message.message);
        }
        else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Course data:', error);
      }
    };

    if (type === "BOTH" && collegetype !== false && selectedAdmission !== false) {
      fetchData();
    }
    else if (type === "AIDED" || type === "SF" && selectedAdmission !== false) {
      fetchData();
    }

  }, [type, collegetype, samecoursetypeselectreload, selectedAdmission]);


  const handlefirstsubmit = () => {

    setFirstSubmit(!isFirstSubmit);
  }
  /* eslint-disable no-restricted-globals */

  const handleSuccess = async () => {

    setFirstSubmit(!isFirstSubmit);

    const selectedData = {
      minor: current.minor.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      mdc: current.mdc.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      aec: current.aec.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      vac: current.VAC.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      sec: current.SEC.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      BevocMinors: current.BevocMinors.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      BvocMDC: current.BvocMDC.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      BvocAEC: current.BvocAEC.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id }))
    };

    try {
      const response = await http.get('/Admin/getCoursegroup');
      const courseGroupData = response.data;

      const courseGroupMap = {};
      courseGroupData.forEach(group => {
        courseGroupMap[group.group_name.toLowerCase()] = group.id;
      });

      const course_group_id = {};
      for (const [key, courses] of Object.entries(selectedData)) {
        if (courses.length > 0) {
          const groupName = key;

          const groupId = courseGroupMap[groupName];

          if (groupId) {
            //Initialize course_group_id[groupid] = [] for MGUGUP courses then push

            if (!course_group_id[groupId]) {
              course_group_id[groupId] = [];

            }
            course_group_id[groupId].push(...courses.map(course => ({ course_id: course.course_id, discipline_id: course.discipline_id })));
          }
          else {

            if (key === "BevocMinors") {

              if (!course_group_id[2]) {
                course_group_id[2] = [];
              }

              course_group_id[2].push(...courses.map(course => ({ course_id: course.course_id, discipline_id: course.discipline_id })));
            }
            else if (key === "BvocMDC") {

              if (!course_group_id[3]) {
                course_group_id[3] = [];
              }

              course_group_id[3].push(...courses.map(course => ({ course_id: course.course_id, discipline_id: course.discipline_id })));
            }

            else if (key === "BvocAEC") {

              if (!course_group_id[4]) {
                course_group_id[4] = [];
              }

              course_group_id[4].push(...courses.map(course => ({ course_id: course.course_id, discipline_id: course.discipline_id })));
            }
          }
        }
      }

      const college_id = localStorage.getItem("collegeid");

      const finalData = {
        college_id: college_id,
        discipline_id: selected,
        semester_id: selctedsem,
        course_group_id,
        college_course_type: collegetype,
        admission_year: selectedAdmission.Adimission_year

      };

      const saveResponse = await http.post(`/Admin/saveSingleFacultyCoursebaskets`, finalData);

      if (saveResponse.data.status_code === "MSG1") {
        toast.success("Updated Successfully");
      }

    } catch (error) {

      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          //navigate("/college/");
        }, 5000);
      } else if (error.response.data.http_status === 422 && error.response.data.status_code == "ERR1") {
        toast.error("Validation Failed");
        setTimeout(() => {
          //window.location.reload();
        }, 1000);
      } else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
        toast.error(error.response.data.message.message);
      } else {
        toast.error("Something went wrong");
        setTimeout(() => {
          //window.location.reload();
        }, 1000);
      }
    }

  };
  /* eslint-enable no-restricted-globals */
  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const handleType = (selectedOption) => {

    const updatedCurrent = Object.keys(current).reduce((acc, key) => {
      acc[key] = [];
      return acc;
    }, {});
    setCurrent(updatedCurrent);
    setSelected([0]);
    setCollegetype(selectedOption.value);
    setSingleFacultyCollegeCourseType(selectedOption.value);
    SetsameCourseTypeSelectReload(!samecoursetypeselectreload);

  };


  const handleCourseComponentChange = (selectedOptions, field) => {

    setCurrent(prevState => ({
      ...prevState,
      [field]: selectedOptions.map(option => ({
        course_id: option.value,
        course_name: option.label,
        discipline_id: option.discipline_id,
      }))
    }));

  };

  const handleDiscipline = (selectedOptions) => {

    if (!selectedOptions || selectedOptions.length === 0) {

      const updatedCurrent = Object.keys(current).reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});
      setCurrent(updatedCurrent);
      setSelected([0]);
    }
    else {
      const selected = selectedOptions.map((option) => option.value);
      setSelected(selected);
    }

  };

  useEffect(() => {


    const course_code = async () => {
      let cid = localStorage.getItem("collegeid");
      const discipline_id = selected;
      const semesterid = selctedsem;

      if (discipline_id && semesterid && collegetype && selectedAdmission.Adimission_year) {
        try {
          const response = await http.get('/Admin/getSingleFacultyCoursebaskets', {
            params: {
              semester_id: semesterid,
              discipline_ids: discipline_id,
              college_id: cid,
              college_course_type: collegetype,
              admission_year: selectedAdmission.Adimission_year
            }
          });

          if (response.data.status_code === 'ERR5') {
            setResults(false);
          }
          else {
            setResults(true);
          }

          setMinors(response.data.minors || []);
          setMdc(response.data.MDC || []);
          setMdc(response.data.MDC || []);
          setAEC(response.data.AEC || []);
          setVAC(response.data.VAC || []);
          setSEC(response.data.SEC || []);
          setBevocMinors(response.data.bvoc_minors || []);
          setBvocMDC(response.data.bvoc_mdc || []);
          setBvocAEC(response.data.bvoc_aec || []);

          const selectedMinors = (response.data.minors || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));

          const selectedMdc = (response.data.MDC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name
            }));

          const selectedAec = (response.data.AEC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name
            }));

          const selectedVAC = (response.data.VAC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));

          const selectedSEC = (response.data.SEC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));
          const selectedBvocMinors = (response.data.bvoc_minors || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));
          const selectedBvocMDC = (response.data.bvoc_mdc || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));
          const selectedBvocAEC = (response.data.bvoc_aec || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name
            }));

          setCurrent(prevState => ({
            ...prevState,
            minor: selectedMinors,
            mdc: selectedMdc,
            aec: selectedAec,
            VAC: selectedVAC,
            SEC: selectedSEC,
            BevocMinors: selectedBvocMinors,
            BvocMDC: selectedBvocMDC,
            BvocAEC: selectedBvocAEC,
          }));


        } catch (error) {
          if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/college/");
            }, 5000);
          }
          else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
            toast.error(error.response.data.message.message);
          }
          else if (error.response.data.status_code === 'ERR5') {
            setResults(false);
          }
          else {
            toast.error("Something went wrong");
          }
          console.error('Error fetching Course data:', error);
        }
      } else {
        toast.error("Select all fields to show results");
      }
    };
    if (selected.length > 0) {
      course_code();
    }

  }, [selected, selctedsem, selectedAdmission.Adimission_year]);


  const cancelForm = () => {
    window.location.reload();
  };


  const handleadmissionyear = (selectedOptions) => {

    const Adimission_year = selectedOptions.value;

    setSelectedAdmission({ Adimission_year: Adimission_year });
    setSelected([]);
    setResults(false);

  };
  console.log("selctedsem", selctedsem)
  //Old event code
  {/*
  useEffect(() => {
    http.get(`getActiveEventsForProgramMap`,
      {
        params: {
          event_id: 1,
          admission_year: selectedAdmission.Adimission_year,
          semester_id: selctedsem
        }
      }).then(response => {

        if (response.data.http_status === 500) {
          setsem(1);
        }
        else if (response.data.length > 0) {

          const activeData = response.data;
          const activeSemesters = activeData[0].semester_id;
          const scheme_id = activeData[0].scheme_id;

          let status1 = "";

          if (scheme_id !== 4) {
            status1 = activeData[0].status;
          } else {
            status1 = "closed";
          }
          const status = status1;

          if (status === "active" && selectedAdmission.Adimission_year == response.data[0].admission_year) {
            setsem(activeSemesters);
            setActiveSemester(activeSemesters);

          }

          const foundBvocEvent = activeData.find(
            (bvocevent) =>
              bvocevent.scheme_id === 4 &&
              bvocevent.admission_year == selectedAdmission.Adimission_year &&
              bvocevent.semester_id == selctedsem &&
              bvocevent.status === "active"
          );

          if (foundBvocEvent) {
            setActiveBvocEvent(true);
            setBvocActiveSemester(foundBvocEvent.semester_id);

          }
          else {
            setActiveBvocEvent(false);
            setBvocActiveSemester(false);

          }

        }
        else {
          setActiveSemester(false);
        }


      }).catch(error => {

        setActiveBvocEvent(false);

        console.error("Error in getStudentCourseEvents:", error);
        //toast.error("Something went wrong");
      });

    if (selectedAdmission.Adimission_year, selctedsem, collegetype) {

    }
  }, [selectedAdmission.Adimission_year, selctedsem, collegetype]);
*/ }
  //Old event code end
  //New Event code for attach all scheme_id
  useEffect(() => {
    if (!selectedAdmission?.Adimission_year || !selctedsem) return;

    http.get(`getActiveEventsForProgramMap`, {
      params: {
        event_id: 1,
        admission_year: selectedAdmission.Adimission_year,
        semester_id: selctedsem
      }
    })
      .then(response => {
        const data = response.data;

        // reset states
        setActiveUGP(false);
        setActiveBVoc(false);

        if (!Array.isArray(data) || data.length === 0) return;

        const filtered = data.filter(event =>
          event.admission_year == selectedAdmission.Adimission_year &&
          event.semester_id == selctedsem &&
          event.status === "active"
        );

        if (filtered.length === 0) return;

        // check UGP schemes
        const hasUGP = filtered.some(e =>
          [1, 2, 3].includes(e.scheme_id)
        );

        // check B.Voc schemes
        const hasBVoc = filtered.some(e =>
          e.scheme_id === 4
        );

        // set flags
        setActiveUGP(hasUGP);
        setActiveBVoc(hasBVoc);

      })
      .catch(err => {
        console.error("Error:", err);
        setActiveUGP(false);
        setActiveBVoc(false);
      });
    if (selectedAdmission.Adimission_year, selctedsem, collegetype) {

    }

  }, [selectedAdmission.Adimission_year, selctedsem, collegetype]);
  //New Event code for attach all scheme_id End


  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  const disciplineStyles = {
    option: (provided, state) => ({
      ...provided,
      color:
        state.data.value === "AIDED"
          ? "green"
          : state.data.value === "SF"
            ? "#252393"
            : provided.color,
    }),

    singleValue: (provided, state) => ({
      ...provided,
      color:
        state.data.value === "AIDED"
          ? "green"
          : state.data.value === "SF"
            ? "#252393"
            : provided.color,
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    })
  };

  return (
    <>
      <ToastContainer />
      <Template>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>Single Faculty  Course Selection</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="card-body custom-input">
                          <div className="row">
                            <div className="col">
                              <div className="mb-3 row">
                                <div className={type === "BOTH" ? "col-md-3" : "col-md-6"}>
                                  <label className="">Admission Year<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="Adimission_year"
                                    name="Adimission_year"
                                    className="form"
                                    styles={customStyles}
                                    options={[
                                      { value: '2024', label: '2024' },
                                      { value: '2025', label: '2025' },
                                    ]}
                                    onChange={handleadmissionyear}
                                  />
                                </div>

                                {type === "BOTH" && (
                                  <div className="col-md-3">
                                    <label className="">Course Type<span className="errorclr">*</span></label>


                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="course_type_id"
                                      name="course_type_id"
                                      styles={disciplineStyles}
                                      className="form"
                                      options={[
                                        { value: 'AIDED', label: 'AIDED' },
                                        { value: 'SF', label: 'Self Finance' }
                                      ]}
                                      onChange={handleType}
                                    />
                                  </div>
                                )}
                                <div className="col-md-6">
                                  <label className="">Discipline<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    styles={customStyles}
                                    className="form"
                                    isMulti
                                    options={flag ? [{ value: '0', label: 'No data found' }] : discipline
                                      .map(disciplines => ({
                                        value: disciplines.id,
                                        label: disciplines.discipline_name
                                      }))

                                    }
                                    value={discipline.filter(disciplines =>
                                      Array.isArray(selected) && selected.some(selecteds => selecteds === disciplines.id)
                                    ).map(selecteds => ({
                                      value: selecteds.id,
                                      label: selecteds.discipline_name
                                    }))}


                                    onChange={handleDiscipline}
                                  />
                                </div>


                              </div>


                              <div className="col-md-12">


                                <ul className="nav nav-tabs justify-content-center">
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 1 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(1)}
                                    >
                                      Sem 1
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 2 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(2)}

                                    >
                                      Sem 2
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 3 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(3)}

                                    >
                                      Sem 3
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 4 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(4)}

                                    >
                                      Sem 4
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 5 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(5)}

                                    >
                                      Sem 5
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 6 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(6)}

                                    >
                                      Sem 6
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 7 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(7)}

                                    >
                                      Sem 7
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 8 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(8)}

                                    >
                                      Sem 8
                                    </a>
                                  </li>
                                </ul>


                              </div>

                              <div className="pgm-map-box">
                                {/* <div className="table-responsive"> */}

                                <table className="display dataTable table-striped table-bordered">


                                  <tbody>

                                    {minors.length > 0 && getresults === true && (
                                      <tr>
                                        <td>Minors</td>
                                        <td>
                                          <Select
                                            id="minor_select"
                                            name="minor_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={minors.map(minor => ({
                                              value: minor.course_id,
                                              label: minor.course_name,
                                              discipline_id: minor.discipline_id,
                                            }))}
                                            value={current.minor.map(selectedMinor => ({
                                              value: selectedMinor.course_id,
                                              label: selectedMinor.course_name,
                                              discipline_id: selectedMinor.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'minor')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active}
                                            isDisabled={!activeUGP}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {mdc.length > 0 && getresults === true && (
                                      <tr>
                                        <td>MDC</td>
                                        <td>
                                          <Select
                                            id="mdc_select"
                                            name="mdc_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={mdc.map(mdcs => ({
                                              value: mdcs.course_id,
                                              label: mdcs.course_name,
                                              discipline_id: mdcs.discipline_id
                                            }))}
                                            value={current.mdc.map(selectedMdc => ({
                                              value: selectedMdc.course_id,
                                              label: selectedMdc.course_name,
                                              discipline_id: selectedMdc.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'mdc')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active}
                                            isDisabled={!activeUGP}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                    {AEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>AEC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={AEC.map(aecs => ({
                                              value: aecs.course_id,
                                              label: aecs.course_name,
                                              discipline_id: aecs.discipline_id
                                            }))}
                                            value={current.aec.map(selectedAec => ({
                                              value: selectedAec.course_id,
                                              label: selectedAec.course_name,
                                              discipline_id: selectedAec.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'aec')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active}
                                            isDisabled={!activeUGP}
                                          />
                                        </td>
                                      </tr>
                                    )}


                                    {VAC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>VAC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={VAC.map(vacs => ({
                                              value: vacs.course_id,
                                              label: vacs.course_name,
                                              discipline_id: vacs.discipline_id
                                            }))}
                                            value={current.VAC.map(selectedVac => ({
                                              value: selectedVac.course_id,
                                              label: selectedVac.course_name,
                                              discipline_id: selectedVac.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'VAC')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active}
                                            isDisabled={!activeUGP}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {SEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>SEC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={SEC.map(secs => ({
                                              value: secs.course_id,
                                              label: secs.course_name,
                                              discipline_id: secs.discipline_id
                                            }))}
                                            value={current.SEC.map(selectedSEC => ({
                                              value: selectedSEC.course_id,
                                              label: selectedSEC.course_name,
                                              discipline_id: selectedSEC.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'SEC')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active}
                                            isDisabled={!activeUGP}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {/* For B.Voc course */}
                                    {BvocMDC.length > 0 && getresults === true && singleFacultyCollegeCourseType === "SF" && (
                                      <tr>
                                        <td>B.Voc MDC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={BvocMDC.map(bvocmdc => ({
                                              value: bvocmdc.course_id,
                                              label: bvocmdc.course_name,
                                              discipline_id: bvocmdc.discipline_id
                                            }))}
                                            value={current.BvocMDC.map(selectedBvocMDC => ({
                                              value: selectedBvocMDC.course_id,
                                              label: selectedBvocMDC.course_name,
                                              discipline_id: selectedBvocMDC.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'BvocMDC')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active && !activeBvocEvent}
                                            isDisabled={!activeBVoc}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {BevocMinors.length > 0 && getresults === true && singleFacultyCollegeCourseType === "SF" && (
                                      <tr>
                                        <td>B.Voc Minors</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={BevocMinors.map(bminors => ({
                                              value: bminors.course_id,
                                              label: bminors.course_name,
                                              discipline_id: bminors.discipline_id
                                            }))}
                                            value={current.BevocMinors.map(selectedBevocMinors => ({
                                              value: selectedBevocMinors.course_id,
                                              label: selectedBevocMinors.course_name,
                                              discipline_id: selectedBevocMinors.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'BevocMinors')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            //isDisabled={selctedsem !== active && !activeBvocEvent}
                                            isDisabled={!activeBVoc}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                    {BvocAEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>B.Voc AEC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={BvocAEC.map(bvocaec => ({
                                              value: bvocaec.course_id,
                                              label: bvocaec.course_name,
                                              discipline_id: bvocaec.discipline_id
                                            }))}
                                            value={current.BvocAEC.map(selectedAEC => ({
                                              value: selectedAEC.course_id,
                                              label: selectedAEC.course_name,
                                              discipline_id: selectedAEC.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'BvocAEC')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active && !activeBvocEvent}
                                          //isDisabled={!activeBVoc} 
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {/* B.Voc course end */}
                                  </tbody>

                                </table>

                                {selected && getresults ? (
                                  <div className="col-md-12 txt-aln pdg11">
                                    {/* {(selctedsem === active || selctedsem === bvocActiveSemester) && ( */}
                                    {/* New code for UGP and Bvoc */}
                                    {(activeUGP || activeBVoc) && (
                                      <div>
                                        <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                                        <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  selected.length < 0 && getresults === false ? (
                                    <p className="txt-aln">No data available. Please select Discipline..</p>
                                  ) : (

                                    <p className="txt-aln">No data available..</p>
                                  )
                                )
                                }


                                <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                  <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                      <div className="modal-body">
                                        <div className="modal-toggle-wrapper">
                                          {/* <ul className="modal-img">
                                                <li> <img src={logo} /></li>
                                              </ul> */}
                                          <h4 className="text-center pb-2">Are you sure you want to proceed?</h4>
                                          <p className="text-center">Any previously saved courses  in the Single Faculty will be deleted, and new courses will be saved under the currently selected course type.</p>
                                          <p className="text-center">Are you sure you want to proceed?</p>
                                          <div className="d-flex justify-content-center mt-3">
                                            {/* {(selctedsem === active || selctedsem === bvocActiveSemester) && ( */}
                                            {/* new code for UGP and Bvoc */}
                                            {(activeUGP || activeBVoc) && (
                                              <div>
                                                <button className="btn btn-danger mx-2" onClick={handleSuccess}>Submit</button>
                                                <button
                                                  className="btn"
                                                  style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                  data-bs-dismiss="modal"
                                                  onClick={handleCancel}
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            )}


                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* </div> */}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
